import React from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames';

const menus = [
  { name: 'ホーム', url: '/' },
  { name: 'ドキュメント', url: '/document' },
  { name: '組織構成', url: '/organization' },
  { name: '目標管理', url: '/plan' },
  { name: '設定', url: '/setting' },
]

const SideMenu = ({ logout, url }) => (
  <aside className="hero is-hidden-mobile">
    <ul className="menu">
      {menus.map(menu =>
        <li className={classnames({ 'active': `${url}/`.startsWith(`${menu.url}/`) })} key={menu.url}>
          <Link to={menu.url}>{menu.name}</Link>
        </li>
      )}
    </ul>
    <ul className="menu hero-foot">
      <li><Link to="/" onClick={logout}>Logout</Link></li>
    </ul>
  </aside>
)
export default SideMenu



// WEBPACK FOOTER //
// ./src/components/SideMenu.js